import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {LabelType, NotificationLabel} from '@techsee/techsee-ui-common/lib/notification-label';
import FormInput from '@techsee/techsee-ui-common/lib/forms/input';
import {PrimaryButton} from '@techsee/techsee-ui-common/lib/forms/buttons/primary';
import {ButtonTypeAttributes} from '@techsee/techsee-ui-common/lib/forms/buttons/generic';
import {IChangePasswordController} from '../../change-password.controller';
import {ScreenLoader} from '../../../../components/screen-loader/screen-loader';

import './styles.scss';

export interface ChangePasswordContentProps {
    controller: IChangePasswordController;
}

@observer
export class ChangePasswordContent extends TechseeBaseComponent<ChangePasswordContentProps> {
    private submitHandler(e?: React.FormEvent) {
        e && e.preventDefault();

        if (e && e.target instanceof HTMLElement) {
            e.target.tabIndex = -1;
            e.target.focus();
        }

        return this.props.controller.onSubmit();
    }

    renderInternal() {
        const {controller} = this.props;
        const {form} = controller;

        if (controller.waiting) {
            return <ScreenLoader />;
        }

        return (
            <div className={'ts-change-password-content'}>
                <div className={'ts-change-password-form-container'}>
                    {controller.message && (
                        <NotificationLabel type={LabelType.Error}>{controller.message}</NotificationLabel>
                    )}

                    <form
                        className={'ts-change-password-form'}
                        onSubmit={this.submitHandler.bind(this)}
                        dir={controller.dir}>
                        <div className={'form-group'}>
                            <FormInput
                                uid={'change-password-old'}
                                className='change-password-old'
                                inputType={'password'}
                                model={form.fields.oldPassword}
                            />
                        </div>

                        <div className={'form-group'}>
                            <FormInput
                                uid={'change-password-new'}
                                className='change-password-new'
                                inputType={'password'}
                                model={form.fields.newPassword}
                            />
                        </div>

                        <div className={'form-group'}>
                            <FormInput
                                uid={'change-password-confirm'}
                                className='change-password-confirm'
                                inputType={'password'}
                                model={form.fields.confirmPassword}
                            />
                        </div>

                        <div className={'ts-change-password-submit'}>
                            <PrimaryButton type={ButtonTypeAttributes.Submit}>
                                {controller.translate('CHANGE_PASSWORD.VIEW.CONFIRM')}
                            </PrimaryButton>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}
